import React from "react";

const KioskHeader = () => {
    return (
        <React.Fragment>
            <p className="text-sm text-[#2B549A] font-semibold mt-3">
                Drop off at any kiosk near you and choose the most convenient delivery option for you:
            </p>
            <ul className="list-disc list-inside text-sm text-[#2B549A] mt-2 text-left">
                <li>Deliver directly to a door</li>
                <li> Send to another convenient kiosk</li>
                <li> Send to a local locker</li>
            </ul>
            <p className="text-sm text-[#2B549A] font-semibold mt-3">How it works</p>
            <p className="text-sm text-[#2B549A] mt-1">
                Once your delivery is captured, you'll receive a WhatsApp from The Courier Guy with your unique barcode and shipment reference.
            </p>
            <p className="text-sm text-[#2B549A] mt-2">
                Simply show the barcode at the kiosk — we will scan it, weigh your parcel, and process the payment. And that's it. Quick and easy!
            </p>
        </React.Fragment>
    )
}

export default KioskHeader;